module.exports = __webpack_public_path__ + "static/media/ic_radioChecked.8407217f.svg";